// 結帳綁卡：輪詢 attempt 狀態，只有後端確認 COMPLETED 才觸發 onCompleted（spec R-3）。
// GHL 收到 success response 後立即呼叫 verify，資料未建好就會拒絕並讓訂閱停在 Incomplete。

export const AGREEMENT_POLL_DEFAULTS = {
  intervalMs: 2000,
  // 短於後端 attempt 的 15 分鐘有效期；逾時只代表前端放棄等待，之後到的 Notify 仍會建資料
  timeoutMs: 10 * 60 * 1000,
  // 付款視窗關閉後再等一段時間，讓已送出的 Notify 有機會先處理完
  closedGraceMs: 15 * 1000,
};

export function pollAgreementStatus({
  fetchStatus,
  isWindowClosed = () => false,
  onCompleted,
  onFailed,
  onClosed,
  onTimeout,
  intervalMs = AGREEMENT_POLL_DEFAULTS.intervalMs,
  timeoutMs = AGREEMENT_POLL_DEFAULTS.timeoutMs,
  closedGraceMs = AGREEMENT_POLL_DEFAULTS.closedGraceMs,
  setTimer = setTimeout,
  clearTimer = clearTimeout,
  now = () => Date.now(),
}) {
  const startedAt = now();
  let closedAt = null;
  let stopped = false;
  let timer = null;

  const finish = (callback, ...args) => {
    if (stopped) return;
    stopped = true;
    callback(...args);
  };

  const tick = async () => {
    if (stopped) return;
    let result = null;
    try {
      result = await fetchStatus();
    } catch (error) {
      result = null; // 暫時性錯誤：繼續輪詢
    }
    if (stopped) return;

    const status = result && result.status;
    if (status === 'COMPLETED') return finish(onCompleted, result.chargeId);
    if (status === 'FAILED' || status === 'EXPIRED') return finish(onFailed, status);

    const current = now();
    if (isWindowClosed()) {
      if (closedAt === null) closedAt = current;
      if (current - closedAt >= closedGraceMs) return finish(onClosed);
    } else {
      closedAt = null;
    }
    if (current - startedAt >= timeoutMs) return finish(onTimeout);

    timer = setTimer(tick, intervalMs);
  };

  timer = setTimer(tick, 0);

  return {
    stop() {
      stopped = true;
      if (timer) clearTimer(timer);
    },
  };
}
